/* global google */

import { useEffect } from 'react';
import type { Location } from '@virginexperiencedays/products';

type MarkerOptions = {
  map: google.maps.Map | undefined;
  infoWindow: google.maps.InfoWindow;
  locations: Location[];
  markers: { lat: number; lng: number }[];
};

export const useMarkers = ({ map, infoWindow, locations, markers }: MarkerOptions) => {
  useEffect(() => {
    if (!map || !markers.length) {
      return;
    }

    const markerInstances: google.maps.Marker[] = [];
    const markerListeners: google.maps.MapsEventListener[] = [];

    markers.forEach(({ lat, lng }, index) => {
      const marker = new google.maps.Marker({
        position: { lat, lng },
        map,
      });

      // Add click event to show infoWindow on marker click
      const clickListener = google.maps.event.addListener(marker, 'click', () => {
        // Close existing infoWindow and clear its listeners first
        infoWindow.close();
        google.maps.event.clearInstanceListeners(infoWindow);
        infoWindow.setContent(locations[index]?.name);
        infoWindow.open(map, marker);
        map.panTo(marker.getPosition());
      });

      markerListeners.push(clickListener);
      markerInstances.push(marker);
    });

    return () => {
      markerInstances.forEach((marker) => {
        marker.setMap(null);
        google.maps.event.clearInstanceListeners(marker);
      });
      markerListeners.forEach((listener) => listener.remove());
      infoWindow.close();
      google.maps.event.clearInstanceListeners(infoWindow);
    };
  }, [map, infoWindow, markers, locations]);
};
